import { lazy } from 'react';

const AwardVerificationDrawer = lazy(() =>
  import('./components/VerificationDrawer'),
);
const DeclineAwardLetterModal = lazy(() =>
  import('./components/DeclineAwardLetterModal'),
);

export default {
  AWARD_VERIFICATION_DRAWER: AwardVerificationDrawer,
  DECLINE_AWARD_LETTER_MODAL: DeclineAwardLetterModal,
};
